import axios from 'axios';
import url from './url.js';


let http = axios.create({
    baseURL: url.devUrl,
    // transformRequest: [function (data) {
    //     // return JSON.stringify(data);
    //     if (data) {
    //         data = JSON.parse(JSON.stringify(data));
    //         let ret = [];
    //         Object.keys(data).forEach(k => {
    //             if (typeof data[k] == "object") {
    //                 data[k] = JSON.stringify(data[k]);
    //             }
    //             ret.push(encodeURIComponent(k) + '=' + encodeURIComponent(data[k]));
    //         });;
    //         return ret.join("&")
    //     }
    // }],
    withCredentials: true,  
    // headers: { 'Cookie': 'asdasdasdsa' },
});

// let http = axios.create({
//     baseURL: url.devUrl,
//     transformRequest: [function (data = {}) {
//         // 全部转换为小写
//         let map = {           
            
//             "GradeClassId": UserInfo.get('GradeClassId'),
//             "roleId": UserInfo.get('RoleDefaultId'),
//         }
//         let _data = {};
//         let _map = {};
//         Object.keys(data).map((key) => {
//             _data[key.toLowerCase()] = data[key];
//         });

//         Object.keys(map).map((key) => {
//             _map[key.toLowerCase()] = map[key];
//         });
//         Object.keys(_map).map((x) => {
//             if (typeof _data[x] == 'undefined') {
//                 _data[x] = _map[x];
//             }
//         });
//         let ret = '';
//         for (let it in _data) {
//             if (typeof _data[it] == "object") {
//                 _data[it] = JSON.stringify(_data[it]);
//             }
//             ret += encodeURIComponent(it) + '=' + encodeURIComponent(_data[it]) + '&'
//         }
//         ret = ret.substring(0, ret.length - 1);
//         return ret
//     }],
// });

// 添加一个请求拦截器
http.interceptors.request.use(function (conf) {
    // conf.headers.Authorization = "token " + localStorage.token;
    // conf.headers['Access-TimeSpan'] = new Date().valueOf(); 
    // console.warn(conf); 
    if (conf.method == 'get') {
        if (!conf.params) conf.params = {};
    }
    return conf;
}, function (error) {
    return Promise.reject(error);
});

// 添加一个响应拦截器

// // 添加一个响应拦截器
http.interceptors.response.use(function (response) {
 
    console.log('response:',response)
    if (typeof response.data == 'object') {

    } else {
        try {
            response.data = JSON.parse(response.data);
        } catch (error) {
            alert('接口调用失败！Result转换出错！' + JSON.stringify(response.data));
        }
    }

    return response.data;
}, function (error) {
    // console.error('接口错误');
      console.error(error);
    if (error.response.status == 401) {
        // 未登录
    }
    return Promise.reject(error);
});


export default http;